import React, { useContext, useEffect, useState } from "react";
import ArticleListItem from "../components/article-list-item";
import Layout from "../components/layout";
import PageSectionContainer from "../components/common/page-section-container";
import PageSectionHeading from "../components/common/page-section-heading";
import AuthContext from "../services/firebase/auth-context/provider";
import { bookmarkedArticleQuery, datoCmsId, fetchFromDatoCms, gatsbyDatoCmsId } from "../services/dato-cms";
import Error from "../components/common/error";
import LoadingSpinner from "../components/common/loading-spinner";
import { StatusType } from "../services/firebase/auth-context/reducer";
import { setBookmarked } from "../services/firebase/bookmarks";
import SEO from "../components/seo";
import Icon, { IconName } from "../components/icon";
var Bookmarks = function Bookmarks() {
    var _useState = useState(null), bookmarkedArticles = _useState[0], setBookmarkedArticles = _useState[1];
    var authContext = useContext(AuthContext);
    var _authContext$ = authContext[0], userData = _authContext$.userData, authenticated = _authContext$.authenticated;
    useEffect(function () {
        if (authenticated && userData.status === StatusType.SUCCESS && userData.data && userData.data.bookmarks) {
            var bookmarks = userData.data.bookmarks;
            fetchBookmarkedArticles(bookmarks);
        }
    }, [authenticated, userData]);
    var fetchBookmarkedArticles = function fetchBookmarkedArticles(bookmarks) {
        var ids = bookmarks.map(function (it) {
            return datoCmsId(it);
        });
        fetchFromDatoCms(bookmarkedArticleQuery(ids)).then(function (result) {
            return result.json();
        }).then(function (data) {
            return setBookmarkedArticles(data.data.allArticles);
        }).catch(function (error) {
            console.error(error);
        });
    };
    var removeBookmark = function removeBookmark(articleId) {
        setBookmarkedArticles(bookmarkedArticles.filter(function (it) {
            return it.id !== articleId;
        }));
        var id = gatsbyDatoCmsId(articleId, "Article");
        setBookmarked(id, false, authContext);
    };
    var renderBookmarkedArticles = function renderBookmarkedArticles() {
        if (bookmarkedArticles && bookmarkedArticles.length > 0) {
            return bookmarkedArticles.map(function (article, index) {
                var _article$image;
                var remove = function remove() {
                    return removeBookmark(article.id);
                };
                return /*#__PURE__*/ React.createElement(ArticleListItem, {
                    key: article.id,
                    authors: article.authors,
                    authorLinks: false,
                    excerpt: article.excerpt,
                    to: "/" + article.slug + "/",
                    title: article.title,
                    image: (_article$image = article.image) === null || _article$image === void 0 ? void 0 : _article$image.responsiveImage,
                    smallTitle: article.smallTitle,
                    containerStyle: "pb-6",
                    index: index
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "w-full flex justify-end"
                }, /*#__PURE__*/ React.createElement("button", {
                    onClick: remove,
                    className: "flex hover:underline"
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "h-8 inline-block mr-2 flex flex-col justify-center"
                }, /*#__PURE__*/ React.createElement(Icon, {
                    iconName: IconName.DELETE,
                    className: "w-3",
                    color: "black"
                })), /*#__PURE__*/ React.createElement("div", {
                    className: "h-8 flex flex-col justify-center"
                }, /*#__PURE__*/ React.createElement("small", null, "Lesezeichen entfernen")))));
            });
        }
        else {
            return /*#__PURE__*/ React.createElement("div", null, "Keine Lesezeichen gesetzt.");
        }
    };
    var renderContent = function renderContent() {
        // TODO Probably the login page should be shown
        if (!authenticated) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "mb-8"
            }, "Diese Funktion ist nur f\xFCr angemeldete Nutzer verf\xFCgbar");
        }
        else if (userData.status === StatusType.ERROR) {
            return /*#__PURE__*/ React.createElement(Error, {
                errorMessage: userData.error.message
            });
        }
        else if (userData.status === StatusType.LOADING || !bookmarkedArticles) {
            return /*#__PURE__*/ React.createElement(LoadingSpinner, null);
        }
        else {
            return renderBookmarkedArticles();
        }
    };
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Lesezeichen"
    }), /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: "LESEZEICHEN"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row flex-wrap"
    }, renderContent())));
};
export default Bookmarks;
